/**
 * E2EE Debug Logger
 *
 * Only logs in dev mode or when ?e2ee_debug is in the URL.
 * Errors always show (they indicate real problems).
 */
const E2EE_DEBUG =
  import.meta.env.DEV ||
  (typeof window !== "undefined" && new URLSearchParams(window.location.search).has("e2ee_debug"));

export const e2eeLog = {
  debug: (...args: unknown[]) => E2EE_DEBUG && console.debug("[E2EE]", ...args),
  info: (...args: unknown[]) => E2EE_DEBUG && console.info("[E2EE]", ...args),
  log: (...args: unknown[]) => E2EE_DEBUG && console.log("[E2EE]", ...args),
  warn: (...args: unknown[]) => E2EE_DEBUG && console.warn("[E2EE]", ...args),
  error: (...args: unknown[]) => console.error("[E2EE]", ...args),
};
